// NOTE: Is this file needed?
import _ from 'lodash';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isEqual = (value: any, other: any): boolean => _.isEqual(value, other);

export const clone = <T>(value: T): T => _.clone(value);

export const cloneDeep = <T>(value: T): T => _.cloneDeep(value);
